import { render, staticRenderFns } from "./SDIStrategiesResults.vue?vue&type=template&id=fcebb55c&scoped=true"
import script from "./SDIStrategiesResults.vue?vue&type=script&lang=js"
export * from "./SDIStrategiesResults.vue?vue&type=script&lang=js"
import style0 from "./SDIStrategiesResults.vue?vue&type=style&index=0&id=fcebb55c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcebb55c",
  null
  
)

export default component.exports